/**
 * 애플 로그인 유틸 (웹: Firebase Auth OAuth 팝업)
 */
import { signInWithPopup } from 'firebase/auth'
import { auth, appleProvider } from '../config/firebase'

/**
 * 웹에서 애플 로그인 실행 후 백엔드용 provider_id(Apple sub) 전달
 */
export const handleAppleLogin = async (
  onSuccess: (providerId: string) => Promise<void>,
  onError: (error: string) => void
): Promise<void> => {
  try {
    const result = await signInWithPopup(auth, appleProvider)
    const user = result.user

    const appleUserInfo = user.providerData.find(
      (p) => p.providerId === 'apple.com'
    )

    if (!appleUserInfo?.uid) {
      throw new Error('애플 로그인 정보를 가져올 수 없습니다.')
    }

    await onSuccess(appleUserInfo.uid)
  } catch (error: any) {
    // 웹은 OAuth(Services ID) 경로라 iOS 네이티브 성공과 오류 코드가 다를 수 있어 원인 파악용으로 남긴다.
    if (error?.code && error.code !== 'auth/popup-closed-by-user') {
      console.error('[AppleAuth]', error.code, error.message || error)
    }

    if (error.code === 'auth/popup-closed-by-user') {
      onError('애플 로그인이 취소되었습니다.')
    } else if (error.code === 'auth/popup-blocked') {
      onError('팝업이 차단되었습니다. 브라우저 설정에서 팝업을 허용해주세요.')
    } else if (error.code === 'auth/unauthorized-domain') {
      onError(
        '이 주소(localhost/도메인)는 Firebase 인증에 등록되지 않았습니다. 콘솔 Authentication → 설정 → 승인된 도메인을 확인해 주세요.'
      )
    } else if (error.code === 'auth/operation-not-allowed') {
      onError(
        '애플 로그인이 설정되지 않았습니다. 관리자에게 문의해 주세요.'
      )
    } else {
      onError(error.message || '애플 로그인 중 오류가 발생했습니다.')
    }
  }
}
